var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProtea(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 501.367,
    height: 176.992,
    viewBox: "0 0 132.653 46.829",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M42.428 73.516h125.524v72.734H42.428z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000",
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: "medium",
      lineHeight: "normal",
      fontFamily: "sans-serif",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontVariantEastAsian: "normal",
      fontFeatureSettings: "normal",
      fontVariationSettings: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecoration: "none",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      letterSpacing: "normal",
      wordSpacing: "normal",
      textTransform: "none",
      writingMode: "lr-tb",
      direction: "ltr",
      textOrientation: "mixed",
      dominantBaseline: "auto",
      baselineShift: "baseline",
      textAnchor: "start",
      whiteSpace: "normal",
      shapePadding: 0,
      shapeMargin: 0,
      inlineSize: 0,
      clipRule: "nonzero",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      isolation: "auto",
      mixBlendMode: "normal",
      colorInterpolation: "sRGB",
      colorInterpolationFilters: "linearRGB",
      solidColor: "#000",
      solidOpacity: 1,
      vectorEffect: "none",
      fill: "#e90000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.529167,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      colorRendering: "auto",
      imageRendering: "auto",
      shapeRendering: "auto",
      textRendering: "auto",
      enableBackground: "accumulate",
      stopColor: "#000"
    },
    d: "M79.231 133.729c-7.938-.007-15.888 2.651-22.701 8.153a16.375 16.521 0 0 1 .355 1.027c6.863-5.528 14.917-8.147 22.943-8.004 9.426.168 18.798 4.15 26.133 11.625a16.375 16.521 0 0 1 .58-.799c-7.495-7.744-17.077-11.825-26.705-11.997a30.518 30.518 0 0 0-.605-.006z",
    transform: "translate(-25.91 -131.555)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000",
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: "medium",
      lineHeight: "normal",
      fontFamily: "sans-serif",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontVariantEastAsian: "normal",
      fontFeatureSettings: "normal",
      fontVariationSettings: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecoration: "none",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      letterSpacing: "normal",
      wordSpacing: "normal",
      textTransform: "none",
      writingMode: "lr-tb",
      direction: "ltr",
      textOrientation: "mixed",
      dominantBaseline: "auto",
      baselineShift: "baseline",
      textAnchor: "start",
      whiteSpace: "normal",
      shapePadding: 0,
      shapeMargin: 0,
      inlineSize: 0,
      clipRule: "nonzero",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      isolation: "auto",
      mixBlendMode: "normal",
      colorInterpolation: "sRGB",
      colorInterpolationFilters: "linearRGB",
      solidColor: "#000",
      solidOpacity: 1,
      vectorEffect: "none",
      fill: "#f77c00",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.529167,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      colorRendering: "auto",
      imageRendering: "auto",
      shapeRendering: "auto",
      textRendering: "auto",
      enableBackground: "accumulate",
      stopColor: "#000"
    },
    d: "M79.231 134.744c-7.83-.006-15.67 2.578-22.421 7.927a16.375 16.521 0 0 1 .309 1.065c6.811-5.4 14.774-7.958 22.71-7.817 9.258.166 18.465 4.011 25.74 11.231a16.375 16.521 0 0 1 .55-.836c-7.432-7.465-16.835-11.396-26.283-11.565a30.518 30.518 0 0 0-.605-.006z",
    transform: "translate(-25.91 -131.555)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000",
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: "medium",
      lineHeight: "normal",
      fontFamily: "sans-serif",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontVariantEastAsian: "normal",
      fontFeatureSettings: "normal",
      fontVariationSettings: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecoration: "none",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      letterSpacing: "normal",
      wordSpacing: "normal",
      textTransform: "none",
      writingMode: "lr-tb",
      direction: "ltr",
      textOrientation: "mixed",
      dominantBaseline: "auto",
      baselineShift: "baseline",
      textAnchor: "start",
      whiteSpace: "normal",
      shapePadding: 0,
      shapeMargin: 0,
      inlineSize: 0,
      clipRule: "nonzero",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      isolation: "auto",
      mixBlendMode: "normal",
      colorInterpolation: "sRGB",
      colorInterpolationFilters: "linearRGB",
      solidColor: "#000",
      solidOpacity: 1,
      vectorEffect: "none",
      fill: "#f7f700",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.529167,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      colorRendering: "auto",
      imageRendering: "auto",
      shapeRendering: "auto",
      textRendering: "auto",
      enableBackground: "accumulate",
      stopColor: "#000"
    },
    d: "M79.231 135.759c-7.735-.006-15.48 2.516-22.175 7.735a16.375 16.521 0 0 1 .259 1.104c6.768-5.295 14.654-7.804 22.513-7.664 9.097.163 18.144 3.877 25.357 10.854a16.375 16.521 0 0 1 .522-.867c-7.365-7.2-16.597-10.991-25.87-11.157a30.518 30.518 0 0 0-.606-.006z",
    transform: "translate(-25.91 -131.555)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000",
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: "medium",
      lineHeight: "normal",
      fontFamily: "sans-serif",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontVariantEastAsian: "normal",
      fontFeatureSettings: "normal",
      fontVariationSettings: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecoration: "none",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      letterSpacing: "normal",
      wordSpacing: "normal",
      textTransform: "none",
      writingMode: "lr-tb",
      direction: "ltr",
      textOrientation: "mixed",
      dominantBaseline: "auto",
      baselineShift: "baseline",
      textAnchor: "start",
      whiteSpace: "normal",
      shapePadding: 0,
      shapeMargin: 0,
      inlineSize: 0,
      clipRule: "nonzero",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      isolation: "auto",
      mixBlendMode: "normal",
      colorInterpolation: "sRGB",
      colorInterpolationFilters: "linearRGB",
      solidColor: "#000",
      solidOpacity: 1,
      vectorEffect: "none",
      fill: "#00753e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.529167,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      colorRendering: "auto",
      imageRendering: "auto",
      shapeRendering: "auto",
      textRendering: "auto",
      enableBackground: "accumulate",
      stopColor: "#000"
    },
    d: "M79.231 136.773c-7.655-.006-15.322 2.464-21.969 7.574a16.375 16.521 0 0 1 .205 1.146c6.734-5.213 14.56-7.684 22.361-7.544 8.952.16 17.855 3.758 25.01 10.521a16.375 16.521 0 0 1 .483-.907c-7.3-6.958-16.372-10.622-25.485-10.784a30.518 30.518 0 0 0-.605-.006z",
    transform: "translate(-25.91 -131.555)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000",
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: "medium",
      lineHeight: "normal",
      fontFamily: "sans-serif",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontVariantEastAsian: "normal",
      fontFeatureSettings: "normal",
      fontVariationSettings: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecoration: "none",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      letterSpacing: "normal",
      wordSpacing: "normal",
      textTransform: "none",
      writingMode: "lr-tb",
      direction: "ltr",
      textOrientation: "mixed",
      dominantBaseline: "auto",
      baselineShift: "baseline",
      textAnchor: "start",
      whiteSpace: "normal",
      shapePadding: 0,
      shapeMargin: 0,
      inlineSize: 0,
      clipRule: "nonzero",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      isolation: "auto",
      mixBlendMode: "normal",
      colorInterpolation: "sRGB",
      colorInterpolationFilters: "linearRGB",
      solidColor: "#000",
      solidOpacity: 1,
      vectorEffect: "none",
      fill: "#3e3ef7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.529167,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      colorRendering: "auto",
      imageRendering: "auto",
      shapeRendering: "auto",
      textRendering: "auto",
      enableBackground: "accumulate",
      stopColor: "#000"
    },
    d: "M79.231 137.788c-7.592-.006-15.195 2.424-21.803 7.45a16.375 16.521 0 0 1 .144 1.188c6.71-5.158 14.496-7.601 22.256-7.462 8.81.157 17.573 3.646 24.67 10.203a16.375 16.521 0 0 1 .456-.933c-7.236-6.734-16.157-10.28-25.118-10.44a30.518 30.518 0 0 0-.605-.006z",
    transform: "translate(-25.91 -131.555)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000",
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: "medium",
      lineHeight: "normal",
      fontFamily: "sans-serif",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontVariantEastAsian: "normal",
      fontFeatureSettings: "normal",
      fontVariationSettings: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecoration: "none",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      letterSpacing: "normal",
      wordSpacing: "normal",
      textTransform: "none",
      writingMode: "lr-tb",
      direction: "ltr",
      textOrientation: "mixed",
      dominantBaseline: "auto",
      baselineShift: "baseline",
      textAnchor: "start",
      whiteSpace: "normal",
      shapePadding: 0,
      shapeMargin: 0,
      inlineSize: 0,
      clipRule: "nonzero",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      isolation: "auto",
      mixBlendMode: "normal",
      colorInterpolation: "sRGB",
      colorInterpolationFilters: "linearRGB",
      solidColor: "#000",
      solidOpacity: 1,
      vectorEffect: "none",
      fill: "#9b00ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.529167,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      colorRendering: "auto",
      imageRendering: "auto",
      shapeRendering: "auto",
      textRendering: "auto",
      enableBackground: "accumulate",
      stopColor: "#000"
    },
    d: "M79.231 138.802c-7.546-.006-15.102 2.396-21.683 7.359a16.375 16.521 0 0 1 .078 1.239c6.698-5.13 14.463-7.56 22.202-7.422 8.69.156 17.334 3.552 24.378 9.937a16.375 16.521 0 0 1 .406-.982c-7.174-6.53-15.956-9.967-24.776-10.125a30.518 30.518 0 0 0-.605-.006z",
    transform: "translate(-25.91 -131.555)"
  }), /*#__PURE__*/React.createElement("g", {
    "aria-label": "Protea",
    transform: "matrix(1.6449 0 0 1.6449 -70.834 -132.087)",
    style: {
      fontStyle: "normal",
      fontWeight: 400,
      fontSize: "35.2778px",
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      whiteSpace: "pre",
      shapeInside: "url(#a)",
      fill: "#333",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.607937
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.497 108.77q-.882 0-1.658-.494-.776-.494-.776-1.27 0-.388.176-.953.177-.529.318-.987 1.129-3.458 2.116-6.456.988-2.999 1.976-5.821.988-2.822 2.081-5.644 1.13-2.823 2.505-5.892-1.34.247-2.399.741-1.023.459-1.658.847-.635.352-.847.352-.14 0-.423-.14-.247-.177-.459-.389-.211-.247-.211-.423.917-.388 2.152-.847 1.27-.458 2.716-.776 1.446-.317 2.928-.317 1.552 0 3.14.423 1.623.423 2.963 1.305 1.34.847 2.152 2.117t.812 2.963q0 1.835-.812 3.175-.811 1.306-2.152 2.223-1.34.882-2.893 1.446-1.552.53-3.104.847-1.517.282-2.716.388-1.2.07-1.764.07h-.353q-1.058 3.634-2.046 7.162-.953 3.528-1.764 6.35zm3.951-14.076q1.94-.106 3.916-.635 2.01-.53 3.669-1.517 1.658-1.023 2.68-2.505 1.024-1.517 1.024-3.527 0-1.905-.917-3.105-.882-1.2-2.364-1.764-1.446-.6-3.104-.6-1.306 2.576-2.54 6.174-1.235 3.598-2.364 7.479zM66.417 106.618q-1.2 0-1.905-.635-.67-.635-.67-1.658 0-1.059.493-2.223.494-1.164.953-2.293.494-1.164.494-2.081 0-1.129-.67-1.658-.636-.565-1.306-1.023-.811 2.081-1.693 3.95-.882 1.87-1.447 2.823l-.317-.6q.494-.917 1.27-2.68.811-1.765 1.587-4.022-.352-.353-.352-.847 0-1.058.6-1.729.599-.67.881-.67.388 0 .424.353.07.317.07.494 0 .176-.212.705-.176.494-.176.6 0 .494.53.917.564.388 1.27.917.705.494 1.234 1.235.564.706.564 1.835 0 1.058-.458 2.152-.424 1.093-.882 2.08-.424.989-.424 1.73 0 .635.318.846.317.212.74.212.847 0 1.73-.53.917-.528 1.763-1.34.847-.811 1.517-1.693.67-.917.988-1.694l.459.353q-.67 1.482-1.835 2.928-1.164 1.411-2.61 2.329-1.411.917-2.928.917z",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: "35.2778px",
      fontFamily: "'Dancing Script'",
      InkscapeFontSpecification: "'Dancing Script'",
      fill: "#ececec",
      strokeWidth: 0.607937,
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.024 106.83q-1.517 0-2.152-.953-.635-.917-.635-2.258 0-1.093.353-2.258.353-1.164.917-2.187.6-1.023 1.306-1.658.74-.635 1.481-.635.177 0 .353.07.212.036.388.107-.317.282-.776 1.058-.423.74-.811 1.729-.388.952-.67 1.905-.248.952-.248 1.622 0 1.059.353 1.553.353.458.917.458.741 0 1.764-.776 1.023-.811 2.011-2.046-.988-.811-1.552-2.117-.53-1.34-.53-2.716 0-1.164.389-2.187.423-1.023 1.2-1.623.775-.635 1.869-.635 1.446 0 1.94.776t.494 1.94q0 1.376-.67 3.07-.67 1.657-1.693 3.21.635.352 1.34.352.565 0 1.27-.211.706-.247 1.376-.812.706-.564 1.129-1.517l.423.353q-.705 1.658-2.01 2.364-1.27.67-2.435.67-.458 0-.882-.07-.423-.106-.811-.283-1.2 1.588-2.646 2.646-1.411 1.059-2.752 1.059zm5.186-5.186q.882-1.306 1.447-2.717.6-1.446.6-2.716 0-1.023-.318-1.482-.282-.494-.741-.494-.706 0-1.446 1.023-.741 1.023-.741 2.576 0 1.023.282 2.081.317 1.023.917 1.729z",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: "35.2778px",
      fontFamily: "'Dancing Script'",
      InkscapeFontSpecification: "'Dancing Script'",
      fill: "#ececec",
      strokeWidth: 0.607937,
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.465 107.323q-1.517 0-2.328-.882-.812-.881-.812-2.61 0-1.552.565-3.81.6-2.293 1.482-4.692-.353-.07-.67-.106-.318-.07-.6-.176v-.635q.282.035.67.07.388.036.882.07.74-1.904 1.587-3.668.847-1.8 1.658-3.175.847-1.411 1.588-2.223.776-.846 1.305-.846.282 0 .494.211.247.177.247.565 0 .6-.74 1.975-.742 1.341-1.835 3.21-1.094 1.87-2.117 4.058H91.146q1.164 0 2.434-.036 1.306-.035 2.611-.176v.635q-1.94.212-3.492.318-1.517.105-2.717.105H89.453q-.811 1.87-1.376 3.846-.564 1.975-.564 3.845 0 1.517.458 2.187.459.635 1.517.635 1.835 0 3.599-1.623 1.763-1.622 3.104-4.41l.459.353q-.847 1.976-2.152 3.563-1.27 1.588-2.823 2.505-1.552.917-3.21.917z",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: "35.2778px",
      fontFamily: "'Dancing Script'",
      InkscapeFontSpecification: "'Dancing Script'",
      fill: "#ececec",
      strokeWidth: 0.607937,
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.33 107.253q-2.151 0-3.245-1.2-1.058-1.164-1.058-2.892 0-1.588.776-3.352.811-1.764 2.117-3.316 1.34-1.552 2.928-2.505 1.587-.987 3.14-.987.81 0 1.481.423.706.423.706 1.729 0 1.34-.812 2.54-.776 1.164-2.081 2.081-1.27.917-2.822 1.517-1.517.564-3.034.705-.07.353-.106.67-.035.318-.035.6 0 .53.105 1.059.142.529.46.988.317.423.846.67.564.247 1.376.247 1.517 0 2.998-.847 1.482-.882 2.752-2.293 1.27-1.411 2.152-3.104l.423.317q-.952 2.117-2.434 3.669-1.446 1.552-3.175 2.399-1.693.882-3.457.882zm-1.728-5.927q.953-.317 2.152-.917 1.2-.635 2.293-1.482 1.129-.846 1.835-1.87.74-1.022.74-2.151 0-.388-.14-.6-.142-.212-.6-.212-.847 0-1.8.67-.952.636-1.834 1.694-.882 1.058-1.588 2.328-.705 1.27-1.058 2.54z",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: "35.2778px",
      fontFamily: "'Dancing Script'",
      InkscapeFontSpecification: "'Dancing Script'",
      fill: "#ececec",
      strokeWidth: 0.607937,
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.962 107.359q-1.094 0-1.835-.741-.776-.706-.776-2.187 0-1.27.564-2.717.565-1.481 1.553-2.893.987-1.446 2.222-2.61 1.27-1.2 2.646-1.905 1.411-.706 2.787-.706t2.293.741q.917.706.917 1.905 0 .882-.494 1.2-.458.317-1.234.317.07-.282.105-.6.071-.352.071-.635 0-.811-.388-1.375-.388-.6-1.34-.6-.988 0-2.011.705-1.024.67-1.976 1.835-.953 1.129-1.693 2.47-.741 1.34-1.165 2.645-.423 1.305-.423 2.328 0 1.376.953 1.376.811 0 1.764-.74.952-.777 1.94-1.94 1.023-1.2 1.94-2.47.917-1.27 1.623-2.329.141-.211.176-.211.212.035.53.14.352.107.6.283.246.176.246.459 0 .317-.317.882-.318.529-.706 1.234-.388.706-.705 1.447-.318.705-.318 1.34 0 .53.282 1.059.282.494.917.494.953 0 2.505-1.376 1.552-1.411 3.14-4.198l.353.352q-.741 1.905-1.905 3.352-1.164 1.446-2.505 2.258-1.305.811-2.575.811-1.306 0-1.94-.776-.6-.776-.6-1.693 0-.212.035-.46l.07-.564q-1.516 2.047-2.786 3.07-1.235 1.023-2.54 1.023z",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: "35.2778px",
      fontFamily: "'Dancing Script'",
      InkscapeFontSpecification: "'Dancing Script'",
      fill: "#ececec",
      strokeWidth: 0.607937,
      fillOpacity: 1
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProtea);
export default __webpack_public_path__ + "static/media/protea.cb5a17094b06909f64de15b581b96621.svg";
export { ForwardRef as ReactComponent };